export default(function(value){return typeof value==='symbol'||typeof value==='object'&&Object.prototype.toString.call(value)==='[object Symbol]';});